import ContactForm from './ContactForm'
import { IconArrowUpRight, IconMail, IconPhone, IconPin } from './ui/Icon'
import RegMark from './ui/RegMark'
import { EMAIL, MAPS_URL, PHONE_DISPLAY, PHONE_HREF, RFQ_I18N } from '../data/rfq-i18n'
import './rfq.css'

/**
 * The RFQ / contact section shared by the home and service pages (id="contact",
 * the navbar's CTA target). The page supplies its own heading copy; the contact
 * details and the form are shared.
 *
 * @param {Object} props
 * @param {'tr'|'en'|'de'} props.lang
 * @param {string} props.title - h2 copy (the page's own, verbatim).
 * @param {string} [props.description] - lead under the heading.
 * @param {string} [props.subjectPrefix] - e-mail subject prefix (service name).
 * @param {string} [props.service] - analytics service dimension.
 * @param {string} [props.formLocation] - analytics form_location dimension.
 */
export default function RfqSection({
  lang = 'tr',
  title,
  description,
  subjectPrefix = '',
  service = 'general',
  formLocation = 'home_contact',
}) {
  const t = RFQ_I18N[lang] || RFQ_I18N.tr

  return (
    <section className="rfq" id="contact" aria-labelledby="rfq-title">
      <div className="container">
        <header className="section-head rfq-head">
          <h2 id="rfq-title">{title}</h2>
          {description ? <p>{description}</p> : null}
        </header>

        <div className="rfq-grid">
          <aside className="rfq-info polymer" aria-labelledby="rfq-info-title">
            <h3 id="rfq-info-title">{t.infoTitle}</h3>
            <p className="rfq-info-lead">{t.infoLead}</p>
            <ul className="rfq-lines">
              <li>
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="rfq-line">
                  <IconPin className="rfq-line-icon" />
                  <span className="rfq-line-text">
                    <span className="legend">{t.address}</span>
                    <span className="rfq-line-value">
                      {t.addressLines[0]}
                      <br />
                      {t.addressLines[1]}
                    </span>
                  </span>
                  <IconArrowUpRight className="rfq-line-go" size={18} />
                </a>
              </li>
              <li>
                <a href={PHONE_HREF} className="rfq-line">
                  <IconPhone className="rfq-line-icon" />
                  <span className="rfq-line-text">
                    <span className="legend">{t.phone}</span>
                    <span className="rfq-line-value tabular">{PHONE_DISPLAY}</span>
                  </span>
                  <IconArrowUpRight className="rfq-line-go" size={18} />
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="rfq-line">
                  <IconMail className="rfq-line-icon" />
                  <span className="rfq-line-text">
                    <span className="legend">{t.email}</span>
                    <span className="rfq-line-value">{EMAIL}</span>
                  </span>
                  <IconArrowUpRight className="rfq-line-go" size={18} />
                </a>
              </li>
              <li>
                <div className="rfq-line rfq-line--static">
                  <RegMark className="rfq-line-icon reg" size={24} />
                  <span className="rfq-line-text">
                    <span className="legend">{t.hours}</span>
                    <span className="rfq-line-value tabular">{t.hoursValue}</span>
                  </span>
                </div>
              </li>
            </ul>
          </aside>

          <div className="rfq-sheet">
            <ContactForm
              lang={lang}
              subjectPrefix={subjectPrefix}
              service={service}
              formLocation={formLocation}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
